import { Pipe, PipeTransform } from '@angular/core';
import { NodeData, NodeType } from '../interfaces/node.interface';
import { coreNodes, CoreNodesEnum, triggerNodes, UserCacheKind } from '../services/graph.utils';

@Pipe({
  name: 'nodeBackgroundColor',
  standalone: true,
})
export class NodeBackgroundColorPipe implements PipeTransform {
  public defaultBackgroundColor = '#d4e8d3';

  public transform(nodeData: NodeData): string {
    const nodeType = nodeData.type?.toLowerCase();

    switch (nodeType) {
      case NodeType.Trigger:
        return triggerNodes()[nodeData.name]?.styles.backgroundColor || this.defaultBackgroundColor;
      case NodeType.Condition:
      case NodeType.If:
      case NodeType.Switch:
      case NodeType.DtoTransformation:
      case NodeType.Loop:
      case NodeType.Wait:
      case NodeType.Terminate:
      case NodeType.End:
      case NodeType.UrlEncoding.toLowerCase():
      case NodeType.Uuid.toLowerCase():
      case NodeType.DtoSet.toLowerCase():
      case NodeType.Gateway:
      case NodeType.Notify:
      case NodeType.HttpResponse:
      case NodeType.HttpRequest:
      case NodeType.EneqtoData.toLowerCase():
        return coreNodes()[nodeData.type]?.styles.backgroundColor || this.defaultBackgroundColor;
      case NodeType.UserCache.toLowerCase():
        switch (nodeData.kind) {
          case UserCacheKind.Read:
            return coreNodes()[CoreNodesEnum.UserCacheRead]?.styles.backgroundColor || this.defaultBackgroundColor;
          case UserCacheKind.Write:
            return coreNodes()[CoreNodesEnum.UserCacheWrite]?.styles.backgroundColor || this.defaultBackgroundColor;
          default:
            return this.defaultBackgroundColor;
        }
      default:
        return this.defaultBackgroundColor;
    }
  }
}
